@if (deviceService.shouldShowBanner()) {
<aside
  class="outdated-banner"
  role="region"
  aria-label="System compatibility warning"
>
  <div class="outdated-banner-content">
    <mat-icon> warning </mat-icon>

    <div class="outdated-banner-text">
      <strong class="outdated-banner-title"
        >{{ 'outdated-ua-banner.title' | translate }}</strong
      >
      <span class="outdated-banner__message">
        {{ 'outdated-ua-banner.message' | translate: { name:
        deviceService.osInfo().name, version: deviceService.osInfo().version }
        }}
      </span>
    </div>

    <button
      matIconButton
      class="outdated-banner-dismiss"
      (click)="dismiss()"
      aria-label="Dismiss warning banner"
    >
      <mat-icon> close </mat-icon>
    </button>
  </div>
</aside>
}
